import React from 'react';
import withUser from './auth/withUser';

const Home = props => {
  props.history.push(defaultRedirectsSwitch(props.user.role));
  return <p>Home</p>;
};
export default withUser(Home);

const defaultRedirectsSwitch = type =>
  ({
    admin: '/admin/',
    client: '/client-profile',
    chef: '/chef-profile'
  }[type] || '/login');



// WEBPACK FOOTER //
// ./src/components/Home.js